<app-unsupported-browser *ngIf='isIE'></app-unsupported-browser>
<ion-app *ngIf='!isIE'>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
